export default function Loading() {
    return (
        <div className="loading">
            <div className="threedots">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>
    );
};